/* ASTORG 1895 | Fiche produit : met à jour la référence affichée dans l'onglet
   « Caractéristiques » quand le client change de variante (taille, couleur…).
   Le thème ne met à jour que son propre bloc référence, pas celle insérée dans l'onglet. */
(function(){
  'use strict';
  var jsonEl = document.querySelector('[id^="ProductJson-"]');
  if (!jsonEl) return;
  var product;
  try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
  if (!product.variants || product.variants.length < 2) return;

  var lastId = null;
  function currentId(){
    var sel = document.querySelector('.product-purchase-form .original-selector');
    var v = (sel && sel.value) ? sel.value : new URLSearchParams(window.location.search).get('variant');
    return v ? parseInt(v, 10) : null;
  }
  function sync(){
    var id = currentId();
    if (!id || id === lastId) return;
    lastId = id;
    var variant = null;
    for (var i = 0; i < product.variants.length; i++) { if (product.variants[i].id === id) { variant = product.variants[i]; break; } }
    if (!variant) return;
    document.querySelectorAll('.product-detail .sku__value').forEach(function(el){
      el.textContent = variant.sku || '';
      var line = el.closest('p');
      if (line) line.style.display = variant.sku ? '' : 'none';
    });
  }

  /* Le thème met l'adresse à jour (?variant=…) à chaque changement de variante. */
  ['pushState', 'replaceState'].forEach(function(m){
    var original = history[m];
    history[m] = function(){ var r = original.apply(this, arguments); setTimeout(sync, 0); return r; };
  });
  /* Filets de sécurité : sélecteurs d'options et liste déroulante. */
  document.addEventListener('change', function(e){ if (e.target.closest && e.target.closest('.product-form')) setTimeout(sync, 0); });
  document.addEventListener('click', function(e){ if (e.target.closest && e.target.closest('.option-selector')) setTimeout(sync, 50); });
  sync();
})();
